import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { useContext, useState } from "react";

const useEditDateOfLastRequest = () => {
  const { lead } = useContext(LeadPageContext);
  const [dateOfLastRequest, setDateOfLastRequest] = useState<
    string | Date | Date[] | null
  >(null);
  const [
    editLeadDateOfLastRequestModalOpen,
    setEditLeadDateOfLastRequestModalOpen,
  ] = useState(false);

  return {
    dateOfLastRequest: {
      editLeadDateOfLastRequestModalOpen,
      setEditLeadDateOfLastRequestModalOpen,
      setDateOfLastRequest,
      state: dateOfLastRequest,
      setState: setDateOfLastRequest,
      initialValue: lead?.data?.lead?.date_of_last_request,
      value: lead?.data?.lead?.date_of_last_request,
    },
  };
};

export default useEditDateOfLastRequest;
